import { useCookies } from 'react-cookie';
import { useAppDispatch } from '@/shared/lib/hooks/redux';
import { setIsAuth } from '@/app/model/slice/appSlice';
import { rtkApi } from '@/shared/api/rtkApi';
import { clearOwnerPreloadFlag } from '@/shared/lib/preloadTechnocoin';
import { useLogoutMutation } from '@/entities/Profile';

export const useLogout = () => {
  const [, , removeCookie] = useCookies();
  const dispatch = useAppDispatch();
  const [logoutMutation] = useLogoutMutation();

  const logout = async () => {
    try {
      await logoutMutation().unwrap();
    } catch {
      return;
    } finally {
      removeCookie('token', { path: '/' });
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('balanceWarningDismissed');
      clearOwnerPreloadFlag();
      dispatch(setIsAuth(false));
      dispatch(rtkApi.util.resetApiState());
    }
  };

  return { logout };
};
